function updateTimer(id, time) {
  const timerElement = document.getElementById(id);
  if (!timerElement) return;
  let targetTime = localStorage.getItem("targetTime"); 
  if (!targetTime) {
    targetTime = new Date().getTime() + time * 60 * 1000; 
    localStorage.setItem("targetTime", targetTime); 
  }
  const interval = setInterval(() => {
    const currentTime = new Date().getTime();
    const timeRemaining = targetTime - currentTime;
    if (timeRemaining < 0) {
      clearInterval(interval);
      localStorage.removeItem("targetTime"); 
      return;
    }
    const minutes = Math.floor((timeRemaining / 1000 / 60) % 60);
    const seconds = Math.floor((timeRemaining / 1000) % 60);
    const formattedMinutes = minutes.toString().padStart(2, '0');
    const formattedSeconds = seconds.toString().padStart(2, '0');
    timerElement.textContent = `${formattedMinutes}:${formattedSeconds}`;
  }, 1000);
}